import { Avatar } from '@mui/material';
import PropTypes from 'prop-types';

export const avatarSizes = {
  default: '45px',
  small: '30px',
  large: '100px',
};
const Image = ({ src, size, alt, shape, children, ...restProps }) => {
  const imageSize = avatarSizes[size] || avatarSizes.default;

  return (
    <Avatar
      alt={alt}
      data-testid="image"
      src={src}
      sx={{ width: imageSize, height: imageSize }}
      variant={shape}
      {...restProps}
    >
      {children}
    </Avatar>
  );
};

Image.propTypes = {
  shape: PropTypes.oneOf(['square', 'circular', 'rounded']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  src: PropTypes.string,
  alt: PropTypes.string,
  children: PropTypes.string,
};

export default Image;
